import './App.css';
import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import {
  FaFacebook,
  FaInstagram,
  FaBars,
  FaTimes,
  FaTrophy,
  FaHeartbeat,
  FaRunning,
  FaShieldAlt
} from "react-icons/fa";
import robone from './img/robone.jpg';
import robtwo from './img/robtwo.jpg';
import robthree from './img/robthree.jpg';
import clientone from './img/client1.jpg';
import clienttwo from './img/client2.jpg';
import clientthree from './img/client3.jpg';
import clientfour from './img/client4.jpg';
import clientfive from './img/client5.jpg';
import Logo from './img/logo.png';
import me from './img/RobOffice.jpg';
import { MdOutlineHealthAndSafety, MdOutlineSportsTennis } from "react-icons/md";
import { HiOutlineDocumentCheck } from "react-icons/hi2";

const NAV_LINKS = [
  { href: "#hero", label: "Home" },
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  { href: "#help", label: "Who I Help" },
  { href: "#pickle", label: "Pickleball" },
  { href: "#contact", label: "Contact" },
];

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ state: "idle", message: "" });

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus({ state: "sending", message: "" });

    emailjs
      .send(
        "service_x0vay7s",
        "template_aegk6ua",
        {
          name: formData.name,
          email: formData.email,
          message: formData.message
        },
        "0CeW4__RY1LdiCeQc"
      )
      .then(() => {
        setStatus({
          state: "success",
          message: "Thanks! Your message is on its way — I'll be in touch soon."
        });
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((err) => {
        console.error(err);
        setStatus({
          state: "error",
          message: "Something went wrong sending your message. Please try again or reach out on social media."
        });
      });
  };

  return (
    <div className="App">
      <nav id="navbar" className={scrolled ? "scrolled" : ""}>
        <a href="#hero" className="brand">
          <img src={Logo} alt="CoachMorganPT logo" />
          <span className="brand-text">
            CoachMorganPT
            <small>Nutrition + Fitness = Life</small>
          </span>
        </a>

        <ul className="nav-links">
          {NAV_LINKS.map((link) => (
            <li key={link.href}><a href={link.href}>{link.label}</a></li>
          ))}
        </ul>

        <button
          type="button"
          className="menu-btn"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </nav>

      {menuOpen && (
        <div className="mobile-nav">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setMenuOpen(false)}>
              {link.label}
            </a>
          ))}
        </div>
      )}

      <section
        id="hero"
        className="hero"
        style={{
          backgroundImage: `linear-gradient(rgba(6,6,6,0.55), rgba(6,6,6,0.9)), url(${clientfour})`
        }}
      >
        <div className="hero-content">
          <span className="eyebrow">Personal Training &amp; Nutrition Coaching</span>
          <h1>Nutrition + Fitness = Life</h1>
          <p>
            Helping active adults reverse metabolic issues, build real strength, and stay
            active for the sports and life they love.
          </p>
          <div className="hero-buttons">
            <a href="#services"><button className="btn btn-primary">View Services</button></a>
            <a href="#contact"><button className="btn btn-outline">Get Started</button></a>
          </div>
          <div className="hero-badges">
            <span>Reversed Type 2 Diabetes</span>
            <span>Certified Coach</span>
            <span>50+ Adults Coached</span>
          </div>
        </div>
      </section>

      <section id="about" className="section">
        <div className="section-inner">
          <h1 className="section-title">About Robert Morgan</h1>
          <p className="eyebrow-text">
            Helping 50+ active adults reverse metabolic issues and stay strong for sports,
            travel, and daily life.
          </p>

          <div className="about-content">
            <img src={me} alt="Robert Morgan, founder of CoachMorganPT" />
            <div className="about-text">
              <p>
                I learned of my pre-diabetic condition after being denied life insurance in
                2008. I changed my diet a little but the diabetes progressed and in 2012, I
                was diagnosed with Type 2 diabetes. I was determined to reverse my condition
                despite the doctors telling me that it was basically impossible.
              </p>
              <p>
                I did my own research, received professional advice from Naturopaths,
                Dietitians, Diabetes Specialists, Endocrinologists. Educated myself, read many
                books, took courses, webinars, sought coaching, became certified. I have
                successfully reversed my Diabetes diagnosis! It is, by far, one of my most
                important successes in life.
              </p>
              <p className="quote">&ldquo;I have always considered myself a champion!&rdquo;</p>
            </div>
          </div>

          <div className="achievements">
            <h2>Achievements</h2>
            <div className="achievement-grid">
              <div className="achievement-card">
                <FaTrophy className="achievement-icon" />
                <h3>Racquetball</h3>
                <ul>
                  <li>Junior 9th in National rankings</li>
                  <li>Senior Ontario Champion (multiple years)</li>
                </ul>
              </div>
              <div className="achievement-card">
                <FaTrophy className="achievement-icon" />
                <h3>Football</h3>
                <ul>
                  <li>Championship teams including AUAA Varsity Champions at Acadia University</li>
                  <li>Started university at Bemidji State University (Minnesota)</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="cards">
            <div className="card"><img src={robone} alt="Robert demonstrating a kettlebell swing" /></div>
            <div className="card"><img src={robtwo} alt="Robert demonstrating TRX suspension training" /></div>
            <div className="card"><img src={robthree} alt="Robert demonstrating a kettlebell squat" /></div>
          </div>
        </div>
      </section>

      <section id="services" className="section alt">
        <div className="section-inner">
          <h1 className="section-title">Services</h1>
          <p className="section-text">
            Helping one client at a time improve their overall health with nutrition
            management and an exercise program that works. No two clients have the same
            needs — that&rsquo;s why every plan is designed around you. Centrally located in
            the Niagara/Hamilton area, convenient to highway access.
          </p>

          <div className="feature-grid">
            <div className="feature">
              <h3>Custom Nutrition Plans</h3>
              <p>Practical, sustainable nutrition guidance built around your goals and lifestyle — not a one-size-fits-all diet.</p>
            </div>
            <div className="feature">
              <h3>Personalized Training</h3>
              <p>Exercise programs designed for your body, your schedule, and the activities you want to keep doing.</p>
            </div>
            <div className="feature">
              <h3>Ongoing Support</h3>
              <p>Regular check-ins and adjustments so your plan keeps working as your life and goals change.</p>
            </div>
          </div>

          <div className="cards">
            <div className="card"><img src={clientone} alt="Personal training session with a client" /></div>
            <div className="card"><img src={clienttwo} alt="Personal training session with a client" /></div>
            <div className="card"><img src={clientthree} alt="Personal training session with a client" /></div>
            <div className="card"><img src={clientfive} alt="Personal training session with a client" /></div>
          </div>
        </div>
      </section>

      <section id="help" className="section">
        <div className="section-inner">
          <h1 className="section-title">Who I Help</h1>
          <p className="eyebrow-text">Reduce blood-sugar swings while gaining strength and energy</p>
          <div className="cards icon-cards">
            <div className="card icon-card">
              <MdOutlineHealthAndSafety className="icon" />
              <h3>Adults 50+ managing diabetes or prediabetes</h3>
            </div>
            <div className="card icon-card">
              <MdOutlineSportsTennis className="icon" />
              <h3>Active adults who want to stay strong for pickleball, skiing, golf, or travel</h3>
            </div>
            <div className="card icon-card">
              <HiOutlineDocumentCheck className="icon" />
              <h3>Busy professionals who need simple, structured programs</h3>
            </div>
          </div>
        </div>
      </section>

      <section id="pickle" className="section alt">
        <div className="section-inner">
          <h1 className="section-title">Pickleball</h1>
          <p className="eyebrow-text">Empowering pickleball players to stay strong and injury free</p>

          <div className="cards pickle-cards">
            <div className="card pickle-card">
              <FaHeartbeat className="icon" />
              <h3>Why Play Pickleball?</h3>
              <p>
                A mental health boost through physical activity and stress relief, increased
                social connection, and a sense of belonging in the pickleball community.
              </p>
            </div>
            <div className="card pickle-card">
              <FaRunning className="icon" />
              <h3>Services Include</h3>
              <p>
                Strength, endurance, power, agility, and speed training — plus injury
                prevention, dynamic warm-ups, cool downs, and stretching built for pickleball.
              </p>
            </div>
            <div className="card pickle-card">
              <FaShieldAlt className="icon" />
              <h3>Preventing Injuries</h3>
              <p>
                Warm up properly, use good technique, wear supportive footwear, stay
                hydrated, take breaks, and stop if something hurts — see a professional for
                personalized support.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="section">
        <div className="section-inner contact-grid">
          <div className="contact-info">
            <h2>Get In Touch</h2>
            <p>Have questions or ready to get started? Send a message and I&rsquo;ll get back to you soon.</p>

            <div className="info-block">
              <h3>Hours</h3>
              <p>Monday–Friday: 9:00AM–5:00PM<br />Saturday &amp; Sunday: 11:00AM–3:00PM</p>
            </div>
            <div className="info-block">
              <h3>Location</h3>
              <p>Centrally located in the Niagara/Hamilton area, convenient to highway access.</p>
            </div>

            <div className="social-icons">
              <a href="https://www.instagram.com/coachmorganpt/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/coachmorganpt" target="_blank" rel="noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
            </div>
          </div>

          <form className="contact-form" onSubmit={sendEmail} noValidate>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              value={formData.name}
              onChange={handleChange}
              disabled={status.state === "sending"}
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
              value={formData.email}
              onChange={handleChange}
              disabled={status.state === "sending"}
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows="5"
              required
              value={formData.message}
              onChange={handleChange}
              disabled={status.state === "sending"}
            />
            <button type="submit" className="btn btn-primary" disabled={status.state === "sending"}>
              {status.state === "sending" ? "Sending…" : "Send"}
            </button>

            <p className="form-status" role="status" aria-live="polite" data-state={status.state}>
              {(status.state === "success" || status.state === "error") ? status.message : ""}
            </p>
          </form>
        </div>
      </section>

      <footer id="footer">
        <div className="footer-brand">
          <img src={Logo} alt="" />
          <span>CoachMorganPT</span>
        </div>

        <ul className="footer-links">
          {NAV_LINKS.map((link) => (
            <li key={link.href}><a href={link.href}>{link.label}</a></li>
          ))}
        </ul>

        <div className="social-icons">
          <a href="https://www.instagram.com/coachmorganpt/" target="_blank" rel="noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://www.facebook.com/coachmorganpt" target="_blank" rel="noreferrer" aria-label="Facebook">
            <FaFacebook />
          </a>
        </div>

        <p className="copyright">© {new Date().getFullYear()} CoachMorganPT. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
